module.exports = __webpack_public_path__ + "img/datangjituan.2446215d.png";